import { css } from '@ui-system/css';
import { createComponentModifiers } from '@ui-system/modifiers';

const componentModifiers = createComponentModifiers(({ theme }) => ({
  error: css`
    border-bottom-color: ${theme.colors[theme.mode].error};
  `,
}));

export default componentModifiers;
